import { awsConfiguration } from "@/aws-configuration";
import { inject, ref, watch, type App, type Ref } from "vue";

export type Settings = {
	apiVersion: Ref<string>;
	organizationId: Ref<string | null>;
};

async function getValue(key: string): Promise<string | null> {
	return localStorage.getItem(key);
}

async function setValue(key: string, value: string): Promise<void> {
	localStorage.setItem(key, value);
}

const apiVersion = ref(
	(await getValue("apiVersion")) ?? awsConfiguration.apiVersion,
);
watch(apiVersion, async newVal => await setValue("apiVersion", newVal));

const organizationId = ref(
	(await getValue("organizationId")) ??
		"3d608862-674a-4a3e-92cc-c78f0ca61edd",
);
watch(
	organizationId,
	async newVal => await setValue("organizationId", newVal || ""),
);

export const useSettings = () => inject<Settings>("app-settings")!;

export const provideSettings = (app: App) => {
	app.provide("app-settings", {
		apiVersion,
		organizationId,
	});
	return {
		apiVersion,
		organizationId,
	};
};
